<template>
	<p class="captcha">
		This site is protected by reCAPTCHA and the Google
		<a target="_blank" href="https://policies.google.com/privacy"
			>Privacy Policy</a
		>
		and
		<a target="_blank" href="https://policies.google.com/terms"
			>Terms of Service</a
		>
		apply.
	</p>
</template>

<script>
export default { name: 'CaptchaNotice' }
</script>

<style lang="scss" scoped>
@import '~scss/vars';

.captcha {
	font-size: 0.875rem;
	color: $grey-32;

	a {
		color: $blue-48;
	}
}
</style>
